import React from 'react';
import routes from 'js/core_pre_webpack/routes';
import styled from 'astroturf/react';
import $image_url from 'js/utils/image_url';
import CoralNewUserDiscountButton from './CoralNewUserDiscountButton';
import _PremiumTextAnchor from "PremiumText-PremiumTextAnchor.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/PremiumText.tsx?styleId=PremiumTextAnchor";
import _Icon from "PremiumText-Icon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/PremiumText.tsx?styleId=Icon";


const PremiumTextAnchor = /*#__PURE__*/styled("a", null, {
  displayName: "PremiumTextAnchor",
  styles: _PremiumTextAnchor
});

const Icon = /*#__PURE__*/styled("img", null, {
  displayName: "Icon",
  styles: _Icon
});

type Props = {
  reactivate?: string;
  coupon?: string;
  coralNewUserDiscountProps?: React.ComponentProps<
    typeof CoralNewUserDiscountButton
  >;
  trialPricingCopy?: string;
};

const PremiumText = (props: Props) => {
  let url;
  let ctaText;

  if (props.trialPricingCopy) {
    ctaText = props.trialPricingCopy;
    url = routes.upgrade_url({
      feature: 'default',
      trigger: 'nav-btn-trial',
      from_navbar: true,
    });
  } else if (props.coralNewUserDiscountProps) {
    const { feature, trigger, couponCode } = props.coralNewUserDiscountProps;
    url = routes.checkout_url({
      feature,
      trigger,
      coupon_code: couponCode,
      from_navbar: true,
    });
    ctaText = '6 Months Free!';
  } else if (props.reactivate) {
    url = routes.checkout_url({
      feature: 'default',
      trigger: 'nav-btn-reactivate',
      premium_discount_coupon: props.coupon,
      from_navbar: true,
    });
    ctaText = 'Reactivate 50% Off';
  } else {
    url = routes.upgrade_url({
      feature: 'default',
      trigger: 'default',
      from_navbar: true,
    });
    ctaText = 'Get Premium';
  }

  return (
    <PremiumTextAnchor href={url}>
      <Icon
        src={$image_url('premium/Lock-CircleGold-White.svg')}
        alt="padlock"
      />
      {ctaText}
    </PremiumTextAnchor>
  );
};

export default PremiumText;
